import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Howl, Howler } from 'howler';
import { createBrowserHistory } from 'history';
import { initialState as jPlayerInitialState } from 'react-jplayer';
import { initialState as jPlaylistInitialState } from 'react-jplaylist';
import configureStore from './store/configureStore';
import testHooks from './testHooks';
import Root from './Root';
import './stylesheets/main.scss';
import LoadingPage from './common/components/LoadingPage';
import TRODemoVideoContainer from './trc/pages/demoVideos/TRODemoVideoContainer';
import { registerServiceWorker } from './common/utils/offlineUtils';
import LCDemoVideoContainer from './lc/pages/demoVideo/LCDemoVideoContainer';
import { isIOS15Safari } from './common/utils/browserUtils';



require.context('./images/owl', true, /\.(png|atlas|json)$/);

/*
    On IOS 15 there is an issue where media files do not load in properly through service
    workers and the browser continuously retries the network request, so we dont register it for now.
*/
// We switch to Content-cache header in S3 bucket setting to provide mp3 files for iOS
registerServiceWorker();

const createEmptySound = () =>
    // This is a workaround for enabling auto play for audio on mobile
    // Start screen does not emit any sound, so howler callbacks for touchend/touchstart
    // setup too late
    new Howl({
        src: ['empty'],
        preload: false,
    });
render(
    <LoadingPage />,
    document.getElementById('app'),
);

const initialState = {
    jPlayers: jPlayerInitialState([TRODemoVideoContainer, LCDemoVideoContainer]),
    jPlaylists: jPlaylistInitialState([TRODemoVideoContainer, LCDemoVideoContainer]),
};

// Web Audio API doesn't work correctly on iOS 15 and above
Howler.usingWebAudio = !isIOS15Safari();
// Context sometimes stuck in 'suspending' state when after idle time of 30 seconds auto-suspend kicks in
// https://github.com/goldfire/howler.js/issues/1524
Howler.autoSuspend = !isIOS15Safari(false);

/* eslint-disable import/prefer-default-export */
export const history = createBrowserHistory();

const storePromise = configureStore(initialState, history);

storePromise.then((store) => {
    window.d394cd2151 = testHooks(store);
    createEmptySound();

    render(
        <Root store={store} history={history} />,
        document.getElementById('app'),
    );
});
